import type { AnalyticsEventData } from '@cbhq/client-analytics';
import { ActionType, ComponentType } from '@cbhq/client-analytics';

export const API_GCO_APPLE_PAY = 'API_GCO_APPLE_PAY_flow';

type NamedAnalyticsEventData = AnalyticsEventData & {
  name: string;
};

const API_GCO_APPLE_PAY_EVENT = {
  action: ActionType.view,
  componentType: ComponentType.page,
};

export const API_GCO_APPLE_PAY_INIT_PARAMS_ERROR: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: '710431fb-3740-4a9d-8d97-c7575b1476ee',
  name: 'API_GCO_APPLE_PAY_INIT_PARAMS_ERROR',
};

export const API_GCO_APPLE_PAY_APPLE_PAY_NOT_SUPPORTED: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: '504ad3a3-b240-46c0-a75a-1e0406c45d32',
  name: 'API_API_GCO_APPLE_PAY_APPLE_PAY_NOT_SUPPORTED',
};

export const API_GCO_APPLE_PAY_APPLE_PAY_NOT_SETUP: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: '52e38675-9d9c-490f-b793-cf883c631c1e',
  name: 'API_GCO_APPLE_PAY_APPLE_PAY_NOT_SETUP',
};

export const API_GCO_APPLE_PAY_APPLE_PAY_SETUP_SUCCESS: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: '8fcd9f9e-a8bc-438d-8a1d-e49264fc12d6',
  name: 'API_GCO_APPLE_PAY_APPLE_PAY_SETUP_SUCCESS',
};

export const API_GCO_APPLE_PAY_VIEWED: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: 'b043b84a-703c-405d-a1b9-c6cf25025273',
  name: 'API_GCO_APPLE_PAY_VIEWED',
};

export const API_GCO_APPLE_PAY_CANCEL: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: 'de97af84-9aa1-4d38-972a-747ae5f779ba',
  name: 'API_GCO_APPLE_PAY_CANCEL',
};

export const API_GCO_APPLE_PAY_VALIDATE_MERCHANT_SUCCESS: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: 'e4178a01-cba1-4271-adf9-6e081cb2c553',
  name: 'API_GCO_APPLE_PAY_VALIDATE_MERCHANT_SUCCESS',
};

export const API_GCO_APPLE_PAY_VALIDATE_MERCHANT_FAILED: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: '02be6baf-0c1b-4cff-a968-d0defa77823b',
  name: 'API_GCO_APPLE_PAY_VALIDATE_MERCHANT_FAILED',
};

export const API_GCO_APPLE_PAY_COMMIT_SUCCESS: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: '616a0828-287e-449c-a661-c67a1f214b31',
  name: 'API_GCO_APPLE_PAY_COMMIT_SUCCESS',
};

export const API_GCO_APPLE_PAY_COMMIT_FAILED: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: 'c02c6dbb-d22a-4425-8987-0760320207cc',
  name: 'API_GCO_APPLE_PAY_COMMIT_FAILED',
};

export const API_GCO_APPLE_PAY_POLLING_SUCCESS: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: '1bded39f-657e-4fac-8670-c11f65034f50',
  name: 'API_GCO_APPLE_PAY_POLLING_SUCCESS',
};

export const API_GCO_APPLE_PAY_POLLING_FAILED: NamedAnalyticsEventData = {
  ...API_GCO_APPLE_PAY_EVENT,
  loggingId: '4f3f3246-d06a-4cf0-b44a-efff7ab67c0b',
  name: 'API_GCO_APPLE_PAY_POLLING_FAILED',
};
